import { Component, OnDestroy, OnInit, ViewChild, ElementRef } from "@angular/core";
import { LoginService } from "../login.service";
import { PatientsService } from "../patients.service";
import { Patient } from "./patient";
import { ExamsService } from "../exams.service";
import { Router } from "@angular/router";
import { Subject, Subscription } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { GastroFormsService } from "../gastro-forms.service";
import { UsgService } from "../usg.service";
import * as XLSX from "xlsx";
import { SignatureService } from "../signature.service";
import { writeFile } from "xlsx";
import { DatePipe } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { pageCount, shouldShowControls, resolveTotal, debouncedSearch } from "../pagination";
import { SPINNER_FADEOUT_DURATION } from "../app.constants";
import { CONSENT_TYPES, resolveConsentTypeKey } from "../consent-types";

@Component({
    selector: "app-patients",
    templateUrl: "./patients.component.html",
    styleUrls: ["./patients.component.scss"],
    standalone: false
})
export class PatientsComponent implements OnInit, OnDestroy {
  @ViewChild("swipeField") swipeField: ElementRef;
  showExcel = false;
  showprintopts = false;
  showprint = false;
  inform = false;
  id: string;
  first: string;
  last: string;
  phone: string;
  idp = 1;
  showhelp: boolean = false;
  selectedPatient: Patient;
  formSelected: any;
  invalidi: string = "";
  invalidf: string = "";
  invalidl: string = "";
  patList: Patient[];
  isAWL = false;
  AWLStatus = "Waiting";
  AWLExam = "All";
  AWLlist: Patient[];
  examList;
  xmlList;
  patientsearch = true;
  fromd: Date;
  tod: Date;
  openEsearch = false;
  isReports = false;
  hmostype;
  exams;
  typeForm;
  examMode = "All";
 
  examNamesUSG = ["Abdomen US", "MSK Musculoskeletal", "MSK & Soft Tissues", "Neck scan", "Ultrasound Scan Summary", "Endoscopy", "Clinics"];
 
  reportsNames = ["Refferelnum", "Macabi", "HMO", "AllReports", "Macabifin"];
  macabiMissing: false | 'codes' | 'refnum' = false;
  examVals = {};
  chosenAWL: number;
  awlTime: string;
  awlExamType: string;
  awlLMP;
  awlComment: string;
  prn: string;
  code: string;
  swiping = false;
  card: string;
  idcode: string;
  carderror: string;
  expcode: string;
  GA;
  GaArray: any[] = [];
  patExams: any[] = [];
  visitPat: any[] = [];
  showpayment: string;
  cardtzsearch: string;
  goEx = { preg: null, exam: null, etype: null };
  showLogin = false;
  startClinic: number;
  private destroy$ = new Subject();
  sub = new Subscription();
  currentPage = 1;
  pageSize = 25;
  totalResults = 0;
  showPaginationControls = false;
  get totalPages(): number {
    return pageCount(this.totalResults, this.pageSize);
  }
  examPage = 1;
  examPageSize = 25;
  examTotal = 0;
  showExamControls = false;
  get examTotalPages(): number {
    return pageCount(this.examTotal, this.examPageSize);
  }
  searchLoading = false;
  examListLoading = false;
  // Set true for the SPINNER_FADEOUT_DURATION window right before the loading flag clears, so the spinner fades out instead of popping away.
  searchFading = false;
  examListFading = false;
  private searchTrigger$ = new Subject<string>();
  startdate;
  enddate;
  changedExamCode;
  reportName = null;
  sentMacabi = false;
  openConcentForm;
  concentForm;
  showUsgConsent = false;
  showUsgConsentModal = false;
  patQuestionnaireAnswered: { [awlid: number]: boolean } = {};
  consentModalPat: any = null;
  consentTypeModal: string = '';
  consentTypes = CONSENT_TYPES;
  readonly CONSENT_EXAM_CODES = ["Gastroscopy", "Colonoscopy", "Gastro + Colonoscopy", "HRA", "Endoscopy", "Clinics"];
  showSendQuestionnaire = false;
  sendQuestionnairePatient: any = null;
  clinicPractitioners: any[] = [];
  consentPractitionerObj: any = null;
  last_search_time;
  toreassign;
  showPopUp = false;
  xmlLoading = false;
  showDownLoad = false;
  unreadLabReports = 0;
  unassignedLabReports = 0;
  macabi2ndRun = false;
  macSearch = false;

  constructor(
    public gs: UsgService,
    public loginService: LoginService,
    public patservice: PatientsService,
    public exServ: ExamsService,
    private rt: Router,
    public gfs: GastroFormsService,
    public signatureService: SignatureService,
    private http: HttpClient
  ) {
    this.id = "";
    this.first = "";
    this.last = "";
    this.phone = "";
   
    // this.AWLStatus ="All";

    for (let e of this.examNamesUSG) this.examVals[e] = true;
  }

  clear() {
    this.id = "";
    this.first = "";
    this.last = "";
    this.phone = "";
    if (this.isAWL) this.search();
  }

  redirectAdministration(type) {
    this.http.post('/api/administration', { type }).subscribe((data: string) => {
      window.location.href = data;
    });
  }

  ngOnInit() {
    debouncedSearch(this.searchTrigger$)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.runSearch());
    let now = new Date();
    let ndate =
      now.getFullYear() +
      "-" +
      (now.getMonth() + 1 < 10 ? "0" : "") +
      (now.getMonth() + 1) +
      "-" +
      (now.getDate() < 10 ? "0" : "") +
      now.getDate();
    now = new Date(ndate);
    this.tod = now;
    this.fromd = now;
    this.loginService.loginMissing();
    if (this.loginService.showAWL()) {
      if (this.loginService.lastAwl) {
        this.AWLStatus = this.loginService.lastAwl;
      }
      if (this.loginService.lastAwlExam) this.AWLExam = this.loginService.lastAwlExam;
      if (this.loginService.lastAwlStartDate && this.loginService.lastAwlEnDate) {
        this.startdate = this.loginService.lastAwlStartDate;
        this.enddate = this.loginService.lastAwlEnDate;
      }

        switch (this.loginService.userType) {
          case "doctor":
            this.AWLStatus = "Completed";
            break;
          case "tech":
            this.AWLStatus = "Received";
            break;
          default:
            this.AWLStatus = "Waiting";
            break;
        }
      
      if (!this.exServ.searchReport) this.AWL();
    }
    this.loginService.onLogin.pipe(takeUntil(this.destroy$)).subscribe(() => {
      if (
        (this.goEx.preg && this.goEx.exam && this.goEx.etype) ||
        (this.goEx && (this.loginService.isUSG || this.loginService.isCardio))
      ) {
        this.exServ.goExam(this.goEx.preg, this.goEx.exam, this.goEx.etype);
      }
    });
    this.patservice.exitFromGastroExam.subscribe(() => {
      this.AWLStatus = this.patservice.AWLStatus;
      this.loginService.lastAwl = "All";
    });
    this.patservice.awlIncomming.pipe(takeUntil(this.destroy$)).subscribe(() => {
      if (this.isAWL) this.AWL();
    });
    if (this.exServ.searchReport) {
      this.fromd = this.exServ.searchReport.start;
      this.tod = this.exServ.searchReport.end;
      this.reportName = this.exServ.searchReport.type;
      this.hmostype = this.exServ.searchReport.hmo;
      this.isReports = true;
      this.AWLlist = null;
      this.searchClosed([this.fromd, this.tod, [], this.reportName, this.hmostype]);
      // this.examSearch(this.reportName, this.hmostype);
    }

    this.sub = this.loginService.export$.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if (!data) {
        this.exServ.searchReport = null;
      }
    });
    setTimeout(() => {
      //moves to patients before permissions are set
      if(this.loginService.premissions?.['GastroLabReports'] && this.loginService.userType == 'doctor'){
        //get number of unread/unassigned reports
        this.gs.getUnreadLabReports().subscribe((data:any)=>{
          this.unreadLabReports = data.UnreadCount;
          this.unassignedLabReports = data.UnassignedCount;
        });
      }
    }, 300);
  }

  addPatient() {
    if (
      !this.loginService.doctor &&
      this.loginService.userType !== "doctor" &&
      this.loginService.separatedClinic
    ) {
      this.showPopUp = true;
      return;
    }
    this.invalidi = "";
    if (this.id.length < 7) {
      this.invalidi = "is-invalid";
      return;
    }
    this.invalidf = "";
    if (this.first == "") {
      this.invalidf = "is-invalid";
      return;
    }
    this.invalidl = "";
    if (this.last == "") {
      this.invalidl = "is-invalid";
      return;
    }
    this.selectedPatient = new Patient(this.id, this.first, this.last, this.phone);
  }

  onClosed(closed: string) {
    if (closed) this.selectedPatient = null;
    if (closed == "awl") {
      this.clear();
      this.AWL();
    } else if (this.patList) this.search(); //to refresh details
    this.awlExamType = null;
    this.awlLMP = null;
    this.awlTime = null;
    this.chosenAWL = null;
    this.prn = null;
    this.code = null;
    this.typeForm = null;
  }

  search(noawl = false) {
    this.examList = null;
    this.xmlList = null;
    this.exServ.searchReport = null;
    this.isReports = false;
    this.carderror = null;
    this.currentPage = 1;
    this.showPaginationControls = false;
    this.searchLoading = true;
    if (this.isAWL && !noawl) {
      this.patList = null;
      if ((this.startdate, this.enddate)) {
        var start =
          this.startdate._i.year +
          "-" +
          (this.startdate._i.month + 1) +
          "-" +
          this.startdate._i.date +
          " 00:00:00.000";
        var end =
          this.enddate._i.year +
          "-" +
          (this.enddate._i.month + 1) +
          "-" +
          this.enddate._i.date +
          " 23:59:59.000";
      }
      this.patservice
        .getAWL(this.AWLStatus, this.AWLExam, {
          id: this.id,
          first: this.first,
          last: this.last,
          start: start,
          end: end,
          uid: this.loginService.doctor,
        })
        .subscribe(
          (patients: Patient[]) => {
            if (patients.length > 0) {
              this.GaArray = [];
              patients.forEach((i) => {
                var GAitem = this.lmpGA(i.ExamLMP);
                this.GaArray.push(GAitem);
                if (i.UID) i["nUID"] = i.UID;
              });
            }
            this.AWLlist = patients;
            this.searchFading = true;
            setTimeout(() => {
              this.searchLoading = false;
              this.searchFading = false;
            }, SPINNER_FADEOUT_DURATION);
            this.loadQuestionnaireStatuses(patients);
            if (this.cardtzsearch) {
              this.swiping = false;
              for (let pat of this.AWLlist) {
                let zeros = pat.ID;
                while (zeros.length < 9) zeros = "0" + zeros;
                if (pat.ID == this.cardtzsearch || zeros == this.cardtzsearch) {
                  this.setAWL(pat);
                  this.selectedPatient = pat;
                  if (this.selectedPatient.HMO != "Macabi") {
                    //now for macabi only
                    this.selectedPatient.HMO = "Macabi";
                    this.patservice
                      .savePatient(this.selectedPatient, this.selectedPatient.PID)
                      .subscribe(
                        (data) => {},
                        (error) => {
                          this.carderror = this.cardtzsearch;
                          console.log(error);
                        }
                      );
                  }
                  this.showpayment = this.cardtzsearch;
                  this.cardtzsearch = null;
                  this.macabi2ndRun = false;
                }
              }
              if (this.cardtzsearch) {
                if (this.hasMacabiFillPermission() && !this.macabi2ndRun) {
                  this.swiping = true;
                  this.macSearch = true;
                  const macabiTimer = setTimeout(() => {
                    this.cancelSearch();
                  }, 60000);
                  this.patservice.macabiAdd(this.cardtzsearch, this.idcode, this.expcode).subscribe(
                    (data) => {
                      this.macSearch = false;
                      this.swiping = false;
                      clearTimeout(macabiTimer);
                      if (data && data["status"] === "ok") {
                        this.macabi2ndRun = true;
                        this.search();
                      } else {
                        this.carderror = data ? data["status"] : "Maccabi lookup failed";
                        this.cardtzsearch = null;
                        this.macabi2ndRun = false;
                      }
                    },
                    () => {
                      clearTimeout(macabiTimer);
                      this.carderror = "Error on Maccabi lookup";
                      this.cardtzsearch = null;
                      this.cancelSearch();
                      this.macabi2ndRun = false;
                    }
                  );
                } else {
                  this.carderror = this.cardtzsearch;
                  this.cardtzsearch = null;
                  this.macabi2ndRun = false;
                }
              }
            }
          },
          (error) => {
            console.log(error);
            this.searchFading = true;
            setTimeout(() => {
              this.searchLoading = false;
              this.searchFading = false;
            }, SPINNER_FADEOUT_DURATION);
          }
        );
    } else {
      this.AWLlist = null;
      // this.visitPat = null;
      this.patservice.getPatients(
        this.id,
        this.first,
        this.last,
        this.phone,
        this.loginService.doctor,
        (patients: Patient[]) => {
          this.patList = [];
          this.isAWL = false;
          for (let i = 0; i < patients.length; i++) {
            let pat = new Patient();
            pat.asignVals(patients[i]);
            this.patList[i] = pat;
          }
          this.totalResults = resolveTotal(patients as any);
          this.showPaginationControls = shouldShowControls(this.totalResults, this.pageSize);
          this.searchFading = true;
          setTimeout(() => {
            this.searchLoading = false;
            this.searchFading = false;
          }, SPINNER_FADEOUT_DURATION);
        },
        this.currentPage,
        this.pageSize,
        () => {
          // A failed request must still clear the spinner, or it spins forever.
          this.searchFading = true;
          setTimeout(() => {
            this.searchLoading = false;
            this.searchFading = false;
          }, SPINNER_FADEOUT_DURATION);
        }
      );
    }
    // }
  }

  cancelSearch() {
    this.macSearch = false;
    this.swiping = false;
  }

  trysearch() {
    this.id = this.id.replace(/\-/g, "_").replace(/\W/g, "").replace(/_/g, "-");
    this.searchTrigger$.next(`${this.id}|${this.first}|${this.last}|${this.phone}`);
  }

  // Debounced search handler.
  private runSearch() {
    if (!this.isSearchDisabled())
      this.search(!this.loginService.ishospital); //for clinics search works on patients - not awl
    if (this.isAWL && this.id.length == 0 && this.first.length == 0 && this.last.length == 0)
      //when cleared
      this.search();
  }

  // Search gate: at least one field with 2+ characters. Shared by auto-search and the Search button.
  // Button gate: the content rule plus an in-flight check, so the button can't be spammed while a search is pending.
  // Kept separate from isSearchDisabled() so a request in flight never blocks the debounced auto-search.
  get isSearchButtonDisabled(): boolean {
    return this.searchLoading || this.isSearchDisabled();
  }

  isSearchDisabled(): boolean {
    return !(
      this.id.trim().length > 1 ||
      this.first.trim().length > 1 ||
      this.last.trim().length > 1 ||
      this.phone.trim().length > 1
    );
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.loadPatients();
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.loadPatients();
    }
  }

  loadPatients() {
    this.searchLoading = true;
    this.patservice.getPatients(
      this.id,
      this.first,
      this.last,
      this.phone,
      this.loginService.doctor,
      (patients: Patient[]) => {
        this.patList = [];
        for (let i = 0; i < patients.length; i++) {
          let pat = new Patient();
          pat.asignVals(patients[i]);
          this.patList[i] = pat;
        }
        this.totalResults = resolveTotal(patients as any);
        this.searchFading = true;
        setTimeout(() => {
          this.searchLoading = false;
          this.searchFading = false;
        }, SPINNER_FADEOUT_DURATION);
      },
      this.currentPage,
      this.pageSize,
      () => {
        // A failed request must still clear the spinner, or it spins forever.
        this.searchFading = true;
        setTimeout(() => {
          this.searchLoading = false;
          this.searchFading = false;
        }, SPINNER_FADEOUT_DURATION);
      }
    );
  }

  AWL(savestatus = true, type = null) {
    if (!this.enddate && this.startdate) {
      this.enddate = this.startdate;
    } else if (!this.startdate && this.enddate) {
      this.startdate = this.enddate;
    }
    if (savestatus) {
      this.loginService.lastAwlExam = this.AWLExam;
      this.loginService.lastAwl = this.AWLStatus;
      this.loginService.lastAwlStartDate = this.startdate;
      this.loginService.lastAwlEnDate = this.enddate;
    }
    this.isAWL = true;
    this.examList = null;
    this.xmlList = null;
    this.exServ.searchReport = null;
    this.search();
    this.patservice.openWebSocket(!this.loginService.ishospital ? this.loginService.ClinicID : null);
  }

  switchSearch() {
    this.patientsearch = !this.patientsearch;
    if (!this.patientsearch) this.examSearch();
    else this.examList = [];
    this.xmlList = [];
  }

  examSearch(reportName = null, hmo = null) {
    this.isAWL = false;
    this.AWLlist = null;
    this.xmlList = null;
    this.visitPat = null;
    this.patList = null;
    this.examListLoading = true;
    if (reportName) {
      this.isReports = true;
      this.reportName = reportName;
      this.hmostype = hmo;
      // reportSearch returns the full unpaginated list, so the exam pager must stay hidden here —
      // reset examTotal/examPage in case a real (paginated) exam search left them non-default.
      this.examTotal = 0;
      this.examPage = 1;
      this.exServ.searchReport = { start: this.fromd, end: this.tod, type: reportName, hmo: hmo };
      this.exServ
        .reportSearch(this.fromd, this.tod, reportName, hmo, this.loginService.doctor, this.macabiMissing)
        .subscribe(
          (data) => {
            this.examList = data;
            this.examListFading = true;
            setTimeout(() => {
              this.examListLoading = false;
              this.examListFading = false;
            }, SPINNER_FADEOUT_DURATION);
          },
          (error) => {
            console.log(error);
            this.examListFading = true;
            setTimeout(() => {
              this.examListLoading = false;
              this.examListFading = false;
            }, SPINNER_FADEOUT_DURATION);
          }
        );
    } else {
      this.isReports = false;
      this.exServ.searchReport = null;
      this.exServ
        .examSearch(
          this.fromd,
          this.tod,
          this.examVals,
          this.loginService.doctor,
          this.examPage,
          this.examPageSize
        )
        .subscribe(
          (data) => {
            this.examList = data;
            this.examTotal = resolveTotal(data as any);
            this.showExamControls = shouldShowControls(this.examTotal, this.examPageSize);
            this.examListFading = true;
            setTimeout(() => {
              this.examListLoading = false;
              this.examListFading = false;
            }, SPINNER_FADEOUT_DURATION);
          },
          (error) => {
            console.log(error);
            this.examListFading = true;
            setTimeout(() => {
              this.examListLoading = false;
              this.examListFading = false;
            }, SPINNER_FADEOUT_DURATION);
          }
        );
    }
  }

  nextExamPage() {
    if (this.examPage < this.examTotalPages) {
      this.examPage++;
      this.examSearch();
    }
  }

  previousExamPage() {
    if (this.examPage > 1) {
      this.examPage--;
      this.examSearch();
    }
  }

  goPatient(pid: number) {
    this.patservice.getPatient(pid, (s) => {
      if (s) this.rt.navigate(["/exams"], { state: { data: this.patservice.currentPatient } });
    });
  }

  getLocked(exam) {
    var now = new Date();
    var lockedTime = new Date(exam.Locked);
    var lock = true;
    if (
      now.getDate() != lockedTime.getDate() ||
      now.getMonth() != lockedTime.getMonth() ||
      now.getFullYear() != lockedTime.getFullYear() ||
      now.getHours() - lockedTime.getHours() > 1
    ) {
      lock = false;
    }
    if ((exam.Locked || lock) && exam.LockedBy && !this.loginService.isAdmin) return "locked";
    return "unlocked";
  }

  viewonly() {
    this.exServ.goExam(this.goEx.preg, this.goEx.exam, this.goEx.etype, true);
  }

  goExam(exam /*PID: number, examID: number, PregIndex: number, etype: string,examtime: string*/) {
    let preg = exam.PregIndex ? { AutoIndex: exam.PregIndex } : null;
    let id = exam.AutoIndex;
    this.patservice.getPatient(exam.PID, (s) => {
      if (s) {
        if (exam.Locked && exam.LockedBy && !this.loginService.isAdmin) return;

        if (
          exam.ExamType !== "Emergency Room" &&
          !this.signatureService.isExamSigned(exam) &&
          (this.loginService.userType === "doctor" ||
            this.loginService.userType === "visitingdoc" ||
            this.loginService.userType === "tech")
        ) {
          this.showLogin = false;
          // Enter exam as view only from the search exam:
          this.exServ.goExam(preg, exam, exam.ExamType, true);
          // this.goEx = { preg: preg, exam: exam, etype: exam.ExamType };
          if (this.loginService.ClinicID) {
            this.startClinic = this.loginService.ClinicID;
          }
        } else {
          this.exServ.goExam(preg, exam, exam.ExamType, s.PID);
        }
      }
    });
  }
  searchClosed($event: any[]) {
    this.macabiMissing = false;
    this.showExcel = true;
    if ($event && $event.length > 3) {
      this.fromd = $event[0];
      this.tod = $event[1];
      if (this.reportsNames.includes($event[3])) {
        this.examSearch($event[3], $event[4]);
      } else {
        this.examVals = $event[2];
        this.examMode = $event[3];
        this.examPage = 1;
        this.examSearch();
      }
    }
    this.openEsearch = false;
  }

  searchXml($event: any[]) {
    this.isAWL = false;
    this.AWLlist = null;
    this.examList = null;
    this.visitPat = null;
    this.patList = null;
    this.isReports = true;
    this.reportName = $event[2];
    this.fromd = $event[0];
    this.tod = $event[1];
    this.openEsearch = false;
    this.exServ.searchReport = { start: this.fromd, end: this.tod, type: this.reportName };
    this.xmlLoading = true;
    this.exServ.xmlReport(this.fromd, this.tod, this.reportName).subscribe(
      (data) => {
        this.xmlLoading = false;
        this.showDownLoad = true;
        this.xmlList = data;
      },
      (error) => {
        this.xmlLoading = false;
        console.log(error);
      }
    );

    console.log($event);
  }

  setAWL(pat) {
    try {
      let edate = new Date(pat.ExamDate);
      this.awlTime = edate.getHours() + ":" + (edate.getMinutes() < 10 ? "0" : "") + edate.getMinutes();
    } catch {
      this.awlTime = null;
    }
    this.awlExamType = pat.ExamCode;

    this.awlLMP = pat.ExamLMP;
    this.awlComment = pat.Reason ? pat.Reason : null;

    this.chosenAWL = pat.AWLID;
  }
  lmpGA(lmp) {
    if (!lmp) return "";
    let dt = new Date();
    let days = Math.floor((dt.getTime() - Date.parse(lmp)) / (1000 * 60 * 60 * 24));
    return Math.floor(days / 7) + "w " + (Math.floor(days) % 7) + "d";
  }

  saveComment(comment: string, AWLID: number) {
    this.patservice.saveAWLComment(comment, AWLID);
  }

  getcard() {
    this.card = "";
    this.id = "";
    this.cardtzsearch = "";
    setTimeout(() => {
      this.swipeField.nativeElement.focus();
    }, 100);
  }

  getTZ() {
    this.cardtzsearch = this.id;
    this.idcode = "0";
    this.expcode = "0";
    if (this.AWLStatus != "All") this.AWLStatus = "All";
    this.AWL(false);
  }

  proccesscard(evt) {
    evt = evt || window.event;
    var isEscape = false;
    if ("key" in evt) isEscape = evt.key === "Escape" || evt.key === "Esc";
    else isEscape = evt.keyCode === 27;

    if (isEscape) this.swiping = false;
    var card = this.card;
    if (this.card && this.card.length > 26 && this.card.includes("8=47"))
      //8=47 is the start of a macabi card
      card = this.card.substring(this.card.indexOf("8=47"));
    if (card && card.length > 26 && !this.cardtzsearch && !this.showpayment) {
      this.cardtzsearch = card.substring(7, 16);
      this.idcode = card.substring(6, 7);
      this.expcode = card.substring(16, 20);
      if (this.AWLStatus != "All") this.AWLStatus = "All";
      this.AWL(false);
    }
  }

  barscan(evt) {
    evt = evt || window.event;
    var isEscape = false;
    if ("key" in evt) isEscape = evt.key === "Escape" || evt.key === "Esc";
    else isEscape = evt.keyCode === 27;

    if (isEscape) this.swiping = false;

    if (
      this.card.trim().length >= 12 &&
      (!this.last_search_time || Date.now() > this.last_search_time + 5000)
    ) {
      //belinson addmission code
      this.last_search_time = Date.now();
      this.patservice.findPatBelinson(this.card.trim()).subscribe(
        (patient: Patient) => {
          if (patient) {
            this.patList = [];
            this.isAWL = false;
            let pat = new Patient();
            pat.asignVals(patient);
            this.patList[0] = pat;
            this.setAWL(pat);
            this.selectedPatient = pat;
            this.swiping = false;
            this.card = "";
            this.awlTime = new Date().toTimeString().substring(0, 5);
          }
        },
        (err) => {
          console.log(err);
        }
      );
    }
  }

  paymentNoCard() {
    this.showpayment = this.selectedPatient.ID;
    while (this.showpayment.length < 9) this.showpayment = "0" + this.showpayment.toString();
    this.idcode = "0";
    this.expcode = null;
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
    this.patservice.closeWebSocket();
  }

  getStatus(status: string): string {
    
    
      switch (status) {
        case "Completed":
          return "Performed";
        case "Waiting":
          return "Scheduled";
        case "Received":
          return "Waiting";
        default:
          return status;
  }
}

  setExamCode(pat) {
    var saveTitle = this.patservice.setExamCode(this.changedExamCode, pat.AWLID);
    saveTitle.subscribe((res) => {
      console.log(res);
      this.changedExamCode = null;
      this.AWL();
    });
  }

  setPatAwlid(pat) {
    this.gfs.paitentLoaded$.next(pat);
  }

  filterExams(exams, type, hmo = null) {
    if (!exams) return [];
    if(hmo)
      return exams.filter((i) => i.ExamType == type && (i.HMO == hmo && i.PRN))
    return exams.filter((i) => i.ExamType == type)
  }

  export() {
    if(this.reportName == 'Macabifin'){
      this.veiwMacabi();
      return;
    }
    var table;
    var strTable;
    var items = ["CreationTime", "ID", "First", "Last", "HMO", "ExamType"];
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    strTable = "<tr>";
    strTable +=
      "<td> חיפוש לפי</td><td>" +
      this.getType(this.exServ.searchReport.type) +
      "</td><td>" +
      this.getHMO(this.exServ.searchReport.hmo) +
      "</td>";
    strTable += "</tr><tr></tr>";
    strTable +=
      "<tr><td>תאריכים</td><td>" +
      this.getDate(this.exServ.searchReport.start) +
      "</td><td>" +
      this.getDate(this.exServ.searchReport.end) +
      "</td></tr>";

    if (this.examList.length > 0) {
      for (let name of this.examNamesUSG) {
        var examTable = "";
        examTable += "<tr>";
        table = document.createElement("table");
        examTable += `<td>${name}</td>`;
        examTable += "</tr>";
        examTable += "<tr>";
        for (let item of items) {
          examTable += `<td><strong>${item}</strong></td>`;
        }
        examTable += "</tr>";
        examTable += "<tr>";
        for (let exam of this.filterExams(this.examList, name)) {
          for (let item of items) {
            var date;
            if (item == "CreationTime") {
              date = exam[item].replace("T", " ").replace("Z", "");

              examTable += `<td>${date}</td>`;
            } else {
              examTable += `<td>${exam[item]}</td>`;
            }
          }
          examTable += "</tr>";
        }
        table.innerHTML = strTable + examTable;
        if (this.filterExams(this.examList, name).length > 0) {
          const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(table);
          XLSX.utils.book_append_sheet(wb, ws, name);
        }
      }
      XLSX.writeFile(wb, new Date().toISOString().split("T")[0] + ".xlsx");
      this.loginService.exportLoading = false;
      this.showLogin = false;
      this.sub.unsubscribe();
    }
  }

  private getComparableDate(date: any): Date | null {
    if (!date) {
      return null;
    }

    if (date instanceof Date) {
      return isNaN(date.getTime()) ? null : date;
    }

    if (date._d instanceof Date) {
      return isNaN(date._d.getTime()) ? null : date._d;
    }

    if (date._i) {
      const parsedDate = new Date(date._i.year, date._i.month, date._i.date);
      return isNaN(parsedDate.getTime()) ? null : parsedDate;
    }

    const parsedDate = new Date(date);
    return isNaN(parsedDate.getTime()) ? null : parsedDate;
  }

  private formatMacabiDate(date: any): string {
    const jsDate = this.getComparableDate(date);

    if (!jsDate) {
      return "";
    }

    const year = jsDate.getFullYear();
    const month = jsDate.getMonth() + 1;
    const day = jsDate.getDate();

    return (
      year +
      "-" +
      (month < 10 ? "0" : "") +
      month +
      "-" +
      (day < 10 ? "0" : "") +
      day
    );
  }

  canSendMacabi(): boolean {
    if (this.reportName === "Macabifin") {
      return !this.macabiMissing;
    }

    if (this.reportName !== "Macabi") {
      return false;
    }

    const fromDate = this.getComparableDate(this.fromd);
    const toDate = this.getComparableDate(this.tod);

    return !!(
      fromDate &&
      toDate &&
      fromDate.getFullYear() === toDate.getFullYear() &&
      fromDate.getMonth() === toDate.getMonth()
    );
  }

  sendMacabi() {
    const startDate = this.formatMacabiDate(this.fromd);
    const endDate = this.formatMacabiDate(this.tod);

    if (!startDate || !endDate) {
      return;
    }

    this.patservice
      .sendMacabi(startDate, endDate)
      .subscribe(
        (data) => {
          this.sentMacabi = true;
        },
        (err) => {
          console.log(err);
        }
      );
  }

  veiwMacabi(){
    this.patservice.getMacabiReprt(this.formatMacabiDate(this.fromd), this.formatMacabiDate(this.tod));
  }

  getMacabiCodesPricesString(exam: any): { codesDisplay: string; totalPrice: string } {
    if (!exam.HMOExamCode || !exam.MacabiPrices) {
      return { codesDisplay: '', totalPrice: '' };
    }

    try {
      let codes = exam.HMOExamCode.split(',').map((c: string) => c.trim()).filter((c: string) => c);
      let prices = JSON.parse(exam.MacabiPrices);

      let codesPricePairs: string[] = [];
      let totalPrice = 0;

      for (let code of codes) {
        let price = prices[code];
        if (price) {
          let priceNum = parseFloat(price);
          totalPrice += priceNum;
          codesPricePairs.push(`${code}: ${parseInt(price || '0')}.${(price || '').split('.')[1] || '00'}`);
        } else {
          codesPricePairs.push(code);
        }
      }

      let codesDisplay = codesPricePairs.join(', ');
      return {
        codesDisplay: codesDisplay,
        totalPrice: totalPrice.toFixed(2)
      };
    } catch (e) {
      return { codesDisplay: '', totalPrice: '' };
    }
  }

  getSubExamLabel(subType: string): string {
    const labels = { Other: '', Gastro: 'Gastroscopy', Colonoscopy: 'Colonoscopy', Both: 'Gastrocolonoscopy' };
    return labels[subType] || subType;
  }

  getHMO(hmo) {
    switch (hmo) {
      case "Macabi":
        return "מכבי";
      case "Leumit":
        return "לאומית";
      case "Meuhedet":
        return "מאוחדת";
      case "Clalit":
        return "כללית";
      case "Private":
        return "פרטי";
      case "IDF":
        return "צהל";
      case "null":
        return "לא שוייכו";
      default:
        return "הכל";
    }
  }
  getType(type) {
    switch (type) {
      case "Macabi":
        return "בדיקות שנשלחו למכבי";
      case "HMO":
        return "קופת חולים";
      case "Refferelnum":
        return "מס' הפניה חסר";
      default:
        return "הכל";
    }
  }
  getDate(date) {
    var temp = new Date(date);
    var str = temp.getDate() + "/" + (temp.getMonth() + 1) + "/" + temp.getFullYear();
    return str;
  }

  startForm(pat) {
    this.exServ.patServ.setPat(pat);
    this.exServ.concentForm = null;
    var res = this.exServ.getConcentForms(pat.PID);
    res.subscribe((data: any) => {
      console.log(data);
      if (!data.hasOwnProperty("empty")) {
        var temp = data.filter((i) => i.ExamType == pat.ExamCode && !i.ExamID);
        if (pat.ExamCode.split(" ")[1] == "Anatomy" || pat.ExamCode.split(" ")[1] == "Trimester")
          var temp = data.filter((i) => i.ExamType == pat.ExamCode.split(" ")[0] && !i.ExamID);
        if (temp.length > 0) {
          this.concentForm = temp[0];
        } else {
          this.exServ.concentForm = null;
          this.exServ.examID = null;
          this.exServ.pregId = null;
          this.exServ.pregnancies = null;
          this.concentForm = null;
        }
      } else {
        this.exServ.examID = null;
        this.exServ.pregId = null;
        this.exServ.pregnancies = null;
        this.exServ.concentForm = null;
        this.concentForm = null;
      }
      this.inform = true;
    });
  }
  getDoctors() {
    return this.loginService.clinicUsers;
  }

  /*reassign(){//move pat and todaylist to another doctor
    this.toreassign.UID = this.toreassign.nUID;
    this.toreassign.nUid = this.toreassign.UID;
    this.patservice.reassign(this.toreassign).subscribe((data)=>{
      this.toreassign = null;
      this.AWL();
    },(error)=>{
      this.toreassign = null;
      this.AWL();
      console.log(error)
    })
  } */ //geting rid of this

  closCalForm(event) {
    this.inform = false;
  }

  getDbName(i, str) {
    var t = i.replace("-", "").split(" ")[0];

    return str + t;
  }

  downloadXml(hmo: string = "Clalit") {
    const downloadUrl = `/api/gastro/downloadXmls/${hmo}`;
    this.exServ.downloadXmls(downloadUrl).subscribe(
      (response) => {
        // Extract the filename from the content-disposition header
        const contentDisposition = response.headers.get("content-disposition");
        const filename = contentDisposition.split(";")[1].trim().split("=")[1];

        // Create an object URL for the blob
        const blob = new Blob([response.body], { type: "application/zip" });
        const url = window.URL.createObjectURL(blob);

        // Create a link element and click it to trigger the download
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();

        // Clean up
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.showDownLoad = false;
      },
      (error) => {
        // Handle error
        console.error("Failed to download ZIP file:", error);
      }
    );
  }

  exporXmlList() {
    const startDate = this.exServ.parseDateDayMonthYear(this.fromd);
    const endDate = this.exServ.parseDateDayMonthYear(this.tod);

    const filteredData = this.xmlList.map((item) => ({
      "Exam Time": item.CreationTime,
      ID: item.ID,
      Name: `${item.First} ${item.Last}`,
      "Exam Type": `${item.ExamType} ${item.Changed ? `(${item.ChangedExamTitle})` : ""}`,
      "Xml File Name": item.xmlName,
    }));

    const sheetName = "Report";
    const fileName = `xml generated list from ${startDate} to ${endDate}.xlsx`;
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    writeFile(workbook, fileName);
  }

  generateXlExams(exams) {
    const datePipe = new DatePipe("en-US");
    let docName;
    if (!this.loginService.isAdmin) {
      docName = this.loginService.username;
    } else {
      docName = this.loginService.getDocByUID(this.loginService.doctor);
    }
    if (!docName) docName = "כולם";

    let clinicName = this.loginService.Clinic;
    if (clinicName === "Best Medical") {
      clinicName = "בסט מדיקל חדרה";
    } else if (clinicName === "Best Medical BY") {
      clinicName = "בסט מדיקל בת ים";
    }
    const filteredData = exams.map((item) => ({
      "תאריך הבדיקה": datePipe.transform(item.CreationTime, "dd-MM-yyyy"),
      "ת.ז של הנבדק/ת": item.ID,
      "שם הנבדק/ת": `${item.First || ""} ${item.Last || ""}`,
      קופה: item.HMO || "",
      "סוג הבדיקה": item.ExamType,
      "שם רופא מבצע": item.OpenerName,
      "נחתם על ידי": item.SignedBy || "",
      "נחתם בתאריך": item.SignedDate ? datePipe.transform(item.SignedDate, "dd-MM-yyyy") : "",
      "נחתם בעבר": (item.SignatureCount > 0 ? "כן" : "") || "",
    }));

    const totalExams = filteredData.length;
    const totalSignedExams = exams.filter((e) => e.SignatureCount > 0).length;
    const totalNotSignedExams = totalExams - totalSignedExams;

    const startDate = this.exServ.parseDateDayMonthYear(this.fromd);
    const endDate = this.exServ.parseDateDayMonthYear(this.tod);

    const sheetName = "examsList";
    const fileName = `exams generated list from ${startDate} to ${endDate}.xlsx`;

    const worksheet = XLSX.utils.json_to_sheet([]);

    XLSX.utils.sheet_add_aoa(worksheet, [[clinicName]], { origin: "A1" });
    XLSX.utils.sheet_add_aoa(worksheet, [[`שם הרופא: ${docName}`]], { origin: "A2" });

    XLSX.utils.sheet_add_json(worksheet, filteredData, { origin: "A4" });

    XLSX.utils.sheet_add_aoa(
      worksheet,
      [
        [
          `סה"כ בדיקות: ${totalExams}`,
          `סה"כ בדיקות חתומות: ${totalSignedExams}`,
          `סה"כ בדיקות לא חתומות: ${totalNotSignedExams}`,
        ],
      ],
      { origin: "A3" }
    );

    worksheet["!cols"] = [{ wch: 30 }];
    const columnCount = Object.keys(filteredData[0] || {}).length;
    worksheet["!cols"] = Array(columnCount).fill({ wch: 30 });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    writeFile(workbook, fileName);
  }

  openHelp() {
    const rawPath = "/assets/pdf/gastro_guide.pdf";
    const encodedPath = encodeURI(rawPath);
    const fullUrl = window.location.origin + encodedPath;

    window.open(fullUrl, "_blank");
  }

  hasMacabiFillPermission(): boolean {
    return !!(this.loginService.premissions && this.loginService.premissions["MacabiFillPatient"]);
  }

  printLabel(hmo:string,pid:number){
    this.patservice.printPatientLabel(hmo,pid).subscribe((data: any) => {}, error => {
      console.error('Error printing label:', error);
    });
  }

  canOpenConsent(examCode: string): boolean {
    return !!examCode && this.CONSENT_EXAM_CODES.includes(examCode);
  }

  defaultConsentType(examCode: string): string {
    if (examCode === 'HRA') {
      return 'HRA';
    }
    if (examCode === 'Gastroscopy' || examCode === 'Colonoscopy' || examCode === 'Gastro + Colonoscopy' || examCode === 'Endoscopy') {
      return 'Endoscopy';
    }
    return '';
  }

  private loadQuestionnaireStatuses(patients: any[]): void {
    if (!this.loginService.premissions?.Questionnaires) return;
    this.patQuestionnaireAnswered = {};
    for (const pat of patients) {
      if (!pat?.PID || !pat?.AWLID) continue;
      this.exServ.getPatientQuestionnaires(pat.PID).subscribe((data: any) => {
        const items = (data && data.items) || [];
        const answered = items.some((i: any) => i.answeredDate && (!pat.ExamCode || i.examCode === pat.ExamCode));
        if (answered) this.patQuestionnaireAnswered[pat.AWLID] = true;
      });
    }
  }

  openUsgConsentFromAWL(pat: any) {
    this.patservice.setPat(pat);
    this.consentModalPat = pat;
    this.consentTypeModal = this.defaultConsentType(pat.ExamCode);
    this.consentPractitionerObj = null;

    const openModal = () => {
      if (this.loginService.userType !== 'doctor' && this.clinicPractitioners.length > 0) {
        if (this.clinicPractitioners.length === 1) {
          this.consentPractitionerObj = this.clinicPractitioners[0];
        } else if (this.loginService.separatedClinic) {
          this.consentPractitionerObj = this.clinicPractitioners.find(p => p.UID == pat.UID) || null;
        } else if (pat.appointmentId) {
          this.consentPractitionerObj = this.clinicPractitioners.find(p => p.UID == pat.AppointmentDocUID) || null;
        }
        // else: multi non-separated, no appointment — leave null, user picks manually
        if (this.consentPractitionerObj) {
          this.exServ.consentPractitioner = this.consentPractitionerObj.Title + ' ' + this.consentPractitionerObj.Name;
          this.setConsentDocUID();
        }
      }
      this.showUsgConsentModal = true;
    };

    const needsPractitioners = !this.loginService.ishospital &&
      this.loginService.userType !== 'doctor' &&
      this.clinicPractitioners.length === 0;

    if (needsPractitioners) {
      this.exServ.getAllPractitioners().subscribe((practitioners: any) => {
        this.clinicPractitioners = practitioners || [];
        if (this.clinicPractitioners.length < 2 && this.clinicPractitioners.length > 0) {
          this.consentPractitionerObj = this.clinicPractitioners[0];
          this.exServ.consentPractitioner = this.consentPractitionerObj.Title + ' ' + this.consentPractitionerObj.Name;
          this.setConsentDocUID();
        }
        openModal();
      });
    } else {
      openModal();
    }
  }

  setConsentDocUID() {
    let selectedDoc: any;
    if (this.loginService.userType === 'doctor') {
      selectedDoc = this.loginService;
    } else {
      selectedDoc = this.clinicPractitioners.find(
        u => u?.Title + ' ' + u?.Name === this.exServ.consentPractitioner
      );
    }
    this.exServ.consentDocUID = selectedDoc?.UID;
  }

  onConsentPractitionerChange(option: any) {
    this.exServ.consentPractitioner = option?.Title + ' ' + option?.Name;
    this.setConsentDocUID();
  }

  confirmUsgConsentModal() {
    if (!this.consentTypeModal) return;
    this.showUsgConsentModal = false;
    this.exServ.consentType = this.consentTypeModal;
    if (this.consentPractitionerObj) {
      this.exServ.consentPractitioner = this.consentPractitionerObj.Title + ' ' + this.consentPractitionerObj.Name;
    }
    this.setConsentDocUID();
    this.exServ.examID = null;
    this.concentForm = null;
    const today = new Date().toDateString();
    this.exServ.getUsgConsents(this.consentModalPat.PID.toString()).subscribe((data: any[]) => {
      const existing = (data || []).find(c =>
        new Date(c.CreationTime).toDateString() === today &&
        resolveConsentTypeKey(c.ConsentType) === this.consentTypeModal
      );
      if (existing) this.concentForm = existing;
      this.showUsgConsent = true;
    });
  }

  closeUsgConsent() {
    this.showUsgConsent = false;
  }

  // AR-24 first-pass send wiring (today list).
  openSendQuestionnaire(pat: any) {
    this.sendQuestionnairePatient = pat;
    this.showSendQuestionnaire = true;
  }
}
